<template>
  <div>
    <v-container>
      <v-card
        class="pb-5"
        min-width="1024px">
        <v-card-title>
          <h3 class="text--black">画面操作ログ</h3>
        </v-card-title>
        <v-card-actions>
          <v-select
            v-model="target"
            label="対象"
            :items="targets"
            @change="fetchItems(0)" />
          <v-text-field
            v-model="keyword"
            prepend-icon="mdi-filter"
            dense
            clearable
            label="案件名・ユーザ名"
            single-line
            hide-details
            style="width: 300px"
            @input="onSearchKeywordChanged">
          </v-text-field>
          <v-select
            v-model="type"
            label="種別"
            :items="types"
            @change="fetchItems(0)" />
        </v-card-actions>
        <v-data-table
          :headers="headers"
          :items="pagination.data"
          :items-per-page="-1"
          :loading="loading"
          :hide-default-footer="true"
          disable-sort
          fixed-header>
          <template #item.created_at="{ item }">
            {{ formatDate(item.created_at, 'YYYY/MM/DD HH:mm:ss') }}
          </template>
        </v-data-table>
        <footer-pagination
          v-model="pagination"
          @change="onPaginationChanged" />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import lodash from 'lodash'
import FooterPagination from '../FooterPagination'

export default {
  name: 'AdminLog',
  components: { FooterPagination },
  props: {
    headers: {
      type: Array,
      default: () => ([
        { value: 'created_at', text: '日時' },
        { value: 'target_name', text: '対象' },
        { value: 'project.title', text: '対象データ' },
        { value: 'type_name', text: '種別' },
        { value: 'user_name', text: 'ユーザ' },
      ]),
    },
    targets: {
      type: Array,
      default: () => ([
        { value: '', text: '全て' },
        { value: 'confirmation', text: '事前準備' },
        { value: 'written-survey', text: '書面調査' },
        { value: 'field-survey', text: '現地調査' },
        { value: 'detail', text: '詳細表' },
        { value: 'report', text: '報告書' },
      ]),
    },
    types: {
      type: Array,
      default: () => ([
        { value: '', text: '全て' },
        { value: '1', text: '閲覧' },
        { value: '2', text: '更新' },
        { value: '3', text: '承認' },
        { value: '5', text: 'ダウンロード' },
      ]),
    },
  },
  data() {
    return {
      loading: false,
      keyword: '',
      pagination: { data: [] },
      currentPage: 1,
      target: '',
      type: '',
    }
  },
  mounted() {
    this.pagination.current_page = this.$route.query.page ?? 0
    this.keyword = this.$route.query.keyword ?? ''
    this.type = this.$route.query.type ?? ''
    this.target = this.$route.query.target ?? ''
    this.pagination.per_page = this.$route.query.count
      ?? window.localStorage.getItem(`pagination-count-${this.name}`)
      ?? '50'
    this.fetchItems()
  },
  methods: {
    onSearchKeywordChanged() {
      this.onDebounceSearchKeywordChanged(this)
    },
    onDebounceSearchKeywordChanged: lodash.debounce((vm) => vm.fetchItems(), 1000, false),
    async fetchItems(page = 0) {
      this.loading = true
      const params = {
        page,
        target: this.target,
        type: this.type,
        keyword: this.keyword,
        count: this.pagination.per_page,
      }
      const { data } = await window.axios.get('/api/activities', { params })
      this.pagination = data
      this.loading = false
      this.$router.replace({
        name: this.$route.name,
        query: params,
      }, () => {}, () => {})
    },
    onPaginationChanged(pagination) {
      this.pagination = pagination
      this.fetchItems(pagination.current_page)
      window.localStorage.setItem(`pagination-count-${this.name}`, this.pagination.per_page)
    },
  },
}
</script>
